import { Typography } from "@mui/material";
import { BRAND_BLUE, BRAND_GREEN } from "../../theme/colors";

export default function SectionLabel({ children }) {
  return (
    <Typography
      variant="h6"
      sx={{
        color: BRAND_BLUE,
        fontWeight: 700,
        borderLeft: `6px solid ${BRAND_GREEN}`,
        pl: 1.5,
        mb: 1,
      }}
    >
      {children}
    </Typography>
  );
}
